import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ModeToggle } from "@/components/mode-toggle";
import Logo from "@/components/logo";
import { motion } from "framer-motion";
import { SEO } from '@/components/SEO';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="404 - Page Not Found"
        description="The page you're looking for couldn't be found. Navigate back to StatusBot's main pages."
      />
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 relative">
        <div className="absolute top-8 left-8">
          <Logo />
        </div>
        <div className="absolute top-8 right-8">
          <ModeToggle />
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center space-y-6"
        >
          <motion.h1
            initial={{ scale: 0.5 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="text-9xl font-bold text-primary"
          >
            404
          </motion.h1>
          <h2 className="text-3xl font-semibold">Oops! Page Not Found</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            It seems you've ventured into uncharted territory. The page you're looking for might have been moved, deleted, or never existed.
          </p>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              size="lg"
              onClick={() => navigate(-1)}
              className="mt-4"
            >
              Go Back
            </Button>
          </motion.div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="mt-16 text-muted-foreground"
        >
          <p>Need assistance? <Button variant="link" className="h-auto p-0 text-primary hover:underline" onClick={() => window.location.href = 'mailto:help@status.bot'}>Contact our support team</Button></p>
        </motion.div>
      </div>
    </>
  );
};

export default NotFound;
